export default "__VITE_ASSET__b213168e__"